import { Injectable } from "@angular/core";
import {
  MessagingStructure,
  MessagingSubFeatures,
  MESSAGING_SUBFEATURES,
} from "./features-by-plan/interface/messaging";
import { FeaturesByPlanService } from "./features-by-plan/features-by-plan.service";
import { BehaviorSubject } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class MessagingService {
  private _messagingCount = new BehaviorSubject<any>(null);
  public messagingCount$ = this._messagingCount.asObservable();
  private _promotionalCount = new BehaviorSubject<any>(null);
  public promotionalCount$ = this._promotionalCount.asObservable();

  messagingFeature: MessagingStructure = {
    zceppa_template: [
      "feature_messaging",
      MESSAGING_SUBFEATURES.zceppa_template,
      "is_applicable",
    ],
    custom_template: [
      "feature_messaging",
      MESSAGING_SUBFEATURES.custom_template,
      "is_applicable",
    ],
    transactional_channel: [
      "feature_messaging",
      MESSAGING_SUBFEATURES.transactional_channel,
      "values",
      ["Email", "SMS", "WhatsApp"],
    ],
    promotional_channel: [
      "feature_messaging",
      MESSAGING_SUBFEATURES.promotional_channel,
      "values",
      ["Email", "SMS", "WhatsApp"],
    ],
    promotional_download_report: [
      "feature_messaging",
      MESSAGING_SUBFEATURES.promotional_download_report,
      "is_applicable",
    ],
    transactional_download_report: [
      "feature_messaging",
      MESSAGING_SUBFEATURES.transactional_download_report,
      "is_applicable",
    ],
    advance_scheduling: [
      "feature_messaging",
      MESSAGING_SUBFEATURES.advance_scheduling,
      "is_applicable",
    ],
  };
  constructor(private featuresByPlan: FeaturesByPlanService) {}

  setTotalCount(data: {
    count: number;
    type: "SENT" | "DRAFT";
    product: "TRANSACTIONAL" | "PROMOTIONAL";
  }) {
    if (data.product == "TRANSACTIONAL") {
      this._messagingCount.next(data);
    } else {
      this._promotionalCount.next(data);
    }
  }

  async checkIsFeatureApplicable(subFeature: keyof MessagingSubFeatures) {
    return (
      await this.featuresByPlan.getFeature(this.messagingFeature[subFeature])
    ).isApplicable();
  }

  async checkFeatureValues(subFeature: keyof MessagingSubFeatures) {
    let subFeatureDetails: any = [...this.messagingFeature[subFeature]];

    let response = (
      await this.featuresByPlan.getFeature(subFeatureDetails)
    ).checkValues();
    return response;
  }
}
